"use strict";
exports.__esModule = true;
var elfProef = function (input, weights) {
    if (typeof input === "number") {
        input = input.toString();
    }
    if (input.length !== weights.length) {
        throw new Error("Amount of weights must be equal to length of input");
    }
    var numbers = input.split("");
    var sum = numbers
        .map(function (value, index) {
        var number = parseInt(value, 10);
        var weight = weights[index];
        return number * weight;
    })
        .reduce(function (a, b) { return a + b; });
    return sum > 0 && sum % 11 === 0;
};
exports["default"] = (function (input) {
    if (typeof input === "number") {
        input = input.toString();
    }
    var validFormat = /^[\d]{9}$/.test(input);
    if (!validFormat) {
        return false;
    }
    return elfProef(input, [9, 8, 7, 6, 5, 4, 3, 2, -1]);
});
